const PEW_RULES =  {
        0: {
            respirations: [{lt4: 15}, {lt2: 20}, {lt: 30},
                {gt4: 89}, {gt2: 79}, {gt: 59}],

            respiratory_distress: [{eq: 'mild'}, {eq2: 'moderate'},
                {eq4: 'severe'}],

            o2_stats: [{lt2: 91}, {lt: 95}],

            o2_flow: [{gte4: 4}, {gt2: 0}],

            pulse: [{gte4: 190}, {gte2: 180}, {gte: 150},
                {lt4: 80}, {lt2: 90}, {lt: 110}],

            blood_pressure: [{lt4: 40}, {lt2: 50}, {lt: 60},
                {gt4: 129}, {gt2: 99}, {gt: 79}],

            capillary_refill: [{eq4: 'more_than_3'}],

            avpu: [{eq: 'v'}, {eq2: 'p'}, {eq4: 'u'}]
        },
        1: {
            respirations: [{lt4: 15}, {lt2: 20}, {lt: 24},
                {gt4: 79}, {gt2: 69}, {gt: 49}],

            respiratory_distress: [{eq: 'mild'}, {eq2: 'moderate'},
                {eq4: 'severe'}],

            o2_stats: [{lt2: 91}, {lt: 95}],

            o2_flow: [{gte4: 4}, {gt2: 0}],

            pulse: [{gte4: 180}, {gte2: 170}, {gte: 150},
                {lt4: 70}, {lt2: 80}, {lt: 100}],

            blood_pressure: [{lt4: 60}, {lt2: 70}, {lt: 80},
                {gt4: 149}, {gt2: 119}, {gt: 99}],

            capillary_refill: [{eq4: 'more_than_3'}],

            avpu: [{eq: 'v'}, {eq2: 'p'}, {eq4: 'u'}]
        },
        2: {
            respirations: [{lt4: 12}, {lt2: 15}, {lt: 20},
                {gt4: 69}, {gt2: 59}, {gt: 39}],

            respiratory_distress: [{eq: 'mild'}, {eq2: 'moderate'},
                {eq4: 'severe'}],

            o2_stats: [{lt2: 91}, {lt: 95}],

            o2_flow: [{gte4: 4}, {gt2: 0}],

            pulse: [{gte4: 170}, {gte2: 150}, {gte: 120},
                {lt4: 60}, {lt2: 70}, {lt: 90}],

            blood_pressure: [{lt4: 70}, {lt2: 80}, {lt: 90},
                {gt4: 159}, {gt2: 119}, {gt: 109}],

            capillary_refill: [{eq4: 'more_than_3'}],

            avpu: [{eq: 'v'}, {eq2: 'p'}, {eq4: 'u'}]
        },
        3: {
            respirations: [{lt4: 10}, {lt2: 14}, {lt: 20},
                {gt4: 49}, {gt2: 39}, {gt: 29}],

            respiratory_distress: [{eq: 'mild'}, {eq2: 'moderate'},
                {eq4: 'severe'}],

            o2_stats: [{lt2: 91}, {lt: 95}],

            o2_flow: [{gte4: 4}, {gt2: 0}],

            pulse: [{gte4: 150}, {gte2: 130}, {gte: 110},
                {lt4: 50}, {lt2: 60}, {lt: 70}],

            blood_pressure: [{lt4: 70}, {lt2: 80}, {lt: 90},
                {gt4: 169}, {gt2: 139}, {gt: 119}],

            capillary_refill: [{eq4: 'more_than_3'}],

            avpu: [{eq: 'v'}, {eq2: 'p'}, {eq4: 'u'}]
        },
        4: {
            respirations: [{lt4: 9}, {lt2: 10}, {lt: 11},
                {gt4: 29}, {gt2: 22}, {gt: 16}],

            respiratory_distress: [{eq: 'mild'}, {eq2: 'moderate'},
                {eq4: 'severe'}],

            o2_stats: [{lt2: 91}, {lt: 95}],

            o2_flow: [{gte4: 4}, {gt2: 0}],

            pulse: [{gte4: 140}, {gte2: 120}, {gte: 100},
                {lt4: 40}, {lt2: 50}, {lt: 60}],

            blood_pressure: [{lt4: 70}, {lt2: 90}, {lt: 100},
                {gt4: 189}, {gt2: 149}, {gt: 129}],

            capillary_refill: [{eq4: 'more_than_3'}],

            avpu: [{eq: 'v'}, {eq2: 'p'}, {eq4: 'u'}]
        },
        5: {

            respirations: [{lte3: 8}, {lt: 12},
                           {gt3: 24}, {gt2: 20}],
            o2_stats: [{lte3: 91}, {lt2: 94}, {lt: 96}],
            on_o2: [{eq2: 'y'}],
            temperature: [{lte3: 35}, {lt: 36.1}, {gte2: 39.1}, {gt: 38}],
            blood_pressure: [{lte3: 90}, {lt2: 101}, {lt: 111},
                             {gte3: 220}],
            pulse: [{gte3: 131}, {gte2: 111}, {gte: 91},
                    {lte3: 40},  {lt: 51}],
            avpu: [{eq3: 'v'}, {eq3: 'p'}, {eq3: 'u'}]

        }

    }



const PewAgeRange = {
  0: '0 - 0.25',
  1: '0.25 - 1',
  2: '1 - 5',
  3: '5 - 12',
  4: '12 - 18',
  5: '18+'
}


let PewGroup = function(age) {
      if (age < 0.25) {
          return 0;
      } else if (age < 1) {
          return 1;
      } else if (age < 5) {
          return 2;
      } else if (age < 12) {
          return 3;
      } else if (age < 18) {
          return 4;
      } else {
          return 5;
      }
}

exports.rules = PEW_RULES;
exports.ageRange = PewAgeRange;
exports.group = PewGroup;
